import type { ServiceOrderDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ServiceOrderService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getByVendor = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceOrderDto[]>({
      method: 'GET',
      url: `/api/app/service-order/by-vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });
}